import { map } from 'lodash';
import { ISearchListColumn } from 'component/Search/IColumnExtensionType';
import { WorksheetName } from '../constants';

export const makeWorkbookFromSheet = (
  columnList: ISearchListColumn[],
  sheetItems: import('exceljs').CellValue[][]
) => {
  /** The names of each column */
  const headerList: import('exceljs').CellValue[] = map(
    columnList,
    c => c.name
  );
  /** The total data as a 2d array of excel cell data */
  const data: import('exceljs').CellValue[][] = [headerList].concat(sheetItems);

  const wb = new (require('exceljs').Workbook)();
  const ws = wb.addWorksheet(WorksheetName, {
    state: 'visible',
    views: [{ ySplit: 1, state: 'frozen' }],
  });
  ws.addRows(data);

  ws.eachRow(row => {
    row.eachCell((cell, colNumber) => {
      if (cell?.value?.hyperlink)
        row.getCell(colNumber).font = {
          color: { argb: '004e47cc' },
          underline: 'single',
        };
    });
  });
  //map over all of our details columns
  map(columnList, (c, i) => {
    if (c.minWidth) {
      ws.getColumn(i + 1).width = c.minWidth / 5;
    }
  });

  return wb;
};
